var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"path1","d":"M6.53,6.56h8v2H.5v-2Z","transform":"translate(-0.5 -0.54)","style":{"fill":"#031e44"},"key":0}),React.createElement("path",{"className":"path2","d":"M8.46,6.57V8.5h0v6h-2v-6h0V6.57h0v-6h2v6Z","transform":"translate(-0.5 -0.54)","style":{"fill":"#031e44"},"key":1})]);
}

Plus.defaultProps = {"id":"e9e480a6-c067-403f-b99d-4e1dd6cadabc","data-name":"Layer 1","width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Plus;

Plus.default = Plus;
